/**
 * Click handler helper
 * @param {*} param0
 */
export const timeChipClickHandler = ({
  disable,
  activeTimes,
  entity,
  label, // This is new in place of id
  handleTimeChipClick,
  sliceRefId,
}) => {
  if (!disable) {
    // if activeTimes exist
    // Deep copy otherwise it freezes the UI as the reference is tampered

    let updatedTimes = structuredClone(activeTimes) || {
      takeoff: [],
      landing: [],
    }

    const activeFilter = updatedTimes?.[`${entity}`] // activeTimes.takeoff vs activeTimes.landing
    if (activeFilter?.includes(label)) {
      const index = activeFilter.indexOf(label)
      if (index > -1) {
        activeFilter.splice(index, 1) // Remove the label if it exists
      }
    } else {
      activeFilter?.push(label) // Add the label if it does not exist
    }

    handleTimeChipClick(activeTimes, updatedTimes, entity, sliceRefId, label, false)
  }
}
